import api from './api'

let swRegistration: ServiceWorkerRegistration | null = null

export async function initPushNotifications(): Promise<void> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('Push notifications not supported')
    return
  }

  try {
    swRegistration = await navigator.serviceWorker.register('/sw.js')
    console.log('Service Worker registered')

    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      await subscribeToPush()
    }
  } catch (error) {
    console.error('Failed to initialize push notifications:', error)
  }
}

async function subscribeToPush(): Promise<void> {
  if (!swRegistration) return

  try {
    const response = await api.get<{ publicKey: string }>('/push/vapid-key')
    const publicKey = response.data.publicKey

    const subscription = await swRegistration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    })

    const subscriptionJson = subscription.toJSON()

    await api.post('/push/subscribe', {
      endpoint: subscriptionJson.endpoint,
      keys: {
        p256dh: subscriptionJson.keys?.p256dh,
        auth: subscriptionJson.keys?.auth
      }
    })

    console.log('Push subscription created')
  } catch (error) {
    console.error('Failed to subscribe to push:', error)
  }
}

export async function unsubscribeFromPush(): Promise<void> {
  if (!swRegistration) return

  try {
    const subscription = await swRegistration.pushManager.getSubscription()
    if (subscription) {
      await api.delete('/push/subscribe', {
        data: { endpoint: subscription.endpoint }
      })
      await subscription.unsubscribe()
      console.log('Push subscription removed')
    }
  } catch (error) {
    console.error('Failed to unsubscribe from push:', error)
  }
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}
